export enum ProjectContactsSortEnum {
  'GOVERNMENT_HEAD',
  'ACCOUNTANT',
  'GOVERNMENT_MEMBER',
  'LEAD_GROUP_MEMBER',
  'TENANT'
}
